import {NestedTreeControl} from '@angular/cdk/tree';
import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MatTreeNestedDataSource, MatTreeModule} from '@angular/material/tree';
import { isDateTime, isGeoPoint, returnDateIfStringFormatZ } from 'na-lib';

interface TridyDataNode {
  name: string;
  value:any;
  children?: TridyDataNode[];
}

@Component({
    selector: '[app-tridys-item-tree-data]',
    templateUrl: './tridys-item-tree-data.component.html',
    styleUrls: ['./tridys-item-tree-data.component.css'],
    standalone: false
})

export class TridysItemTreeDataComponent {
  @Input('app-tridys-item-tree-data') data:any;

  treeControl = new NestedTreeControl<TridyDataNode>(node => node.children);
  dataSource = new MatTreeNestedDataSource<TridyDataNode>();
  TREE_DATA: TridyDataNode[] = []
  visibleTree = false
  treeLength = 0

  constructor() {
  }

  ngOnChanges(){
    this.showObjectData(this.data[0], this.data[1], this.data[3])
  }
  hasChild = (_: number, node: TridyDataNode) => !!node.children && node.children.length > 0;
  isArrayType = (_: number, node: TridyDataNode) => node.children;

  showObjectData(payload0, payload1, index){
    let TREE_DATA = []
    const keys = Object.keys(payload1)
    this.treeLength = keys.length ?? 0

    keys?.forEach(async (key) => {
      let node = { name: key ,value: payload1[key], children: [] };
      if (this.isObject(payload1[key])) {
        node.name = key;
        const value:any = payload1[key]

        if( value?.seconds || value?.nanoseconds || value?._seconds || value?._nanoseconds)
            node.value =  isDateTime(value)
        else if( isGeoPoint(value)){
          const lat = value.lat ? value.lat : (value.latitude ? value.latitude : (value._latitude ? value._latitude : 0))
          const lng = value.lng ? value.lng : (value.longitude ? value.longitude : (value._longitude ? value._longitude : 0))
          node.value = lat + ', ' + lng
        }
        else{
          const children = this.loadChildrenNode(payload1, key);
          node.children = children;
        }
      }

      const dateZ = returnDateIfStringFormatZ(payload1[key])
      if(dateZ){
        const date = new Date(dateZ)
        const formatted = new Intl.DateTimeFormat('de-DE', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        }).format(date);
        node.value = formatted
      }

      if (node.children?.length == 0)
        delete node.children;
      TREE_DATA.push(node);

    })
      const dataSource = new MatTreeNestedDataSource<TridyDataNode>();
      dataSource.data = TREE_DATA
      this.dataSource = dataSource
    return dataSource
  }

  loadChildrenNode(payload1, Nodekey){
    const subkeys = Object.keys(payload1[Nodekey]) ?? []

    if(subkeys.length!=0){
      let childs = []
      const childrens =  subkeys.forEach( async (key) => {
        if(this.isObject(payload1[Nodekey][key])){
        const value:any = payload1[Nodekey][key]

          if( value.seconds || value.nanoseconds)
            childs.push({ name: key , value: isDateTime(value)}) 
          else if( isGeoPoint(value)){///value.lat || value.lng || value.latitude || value.longitude || value._latitude || value._longitude
            const lat = value.lat ? value.lat : (value.latitude ? value.latitude : (value._latitude ? value._latitude : 0))
            const lng = value.lng ? value.lng : (value.longitude ? value.longitude : (value._longitude ? value._longitude : 0))
            const latlong = lat + ', ' + lng
            childs.push(  { name: key , value: latlong})
          }else{
            //does it has to be inside else ???? TODO
            const children = this.loadChildrenNode(payload1[Nodekey], key)
            if(children)
            childs.push( {name:key,children :children})
          }

        }else{
          let value:any = payload1[Nodekey][key]
          const dateZ = returnDateIfStringFormatZ(value)
          if(dateZ){
            const date = new Date(dateZ)
            const formatted = new Intl.DateTimeFormat('de-DE', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: false,
            }).format(date);
            value = formatted
          }
          childs.push( { name: key , value})
        } 
      })
      return childs
    }else
      return  []
  }

  isObject(obj){
    return typeof obj === 'object'; 
  }

  getAncestors(array, name) {
    if (typeof array != "undefined") {
      for (let i = 0; i < array.length; i++) {
        if (array[i].name === name) {
          return [array[i]];
        }
        const a = this.getAncestors(array[i].properties, name);
        if (a !== null) {
          a.unshift(array[i]);
          return a;
        }
      }
    }
    return null;
  }
  childrenAccessor = (node: TridyDataNode) => node.children ?? [];
  onLeafNodeClick(node: TridyDataNode) {    
    const ancestors = this.getAncestors(this.dataSource.data, node.name) ?? []
    let indexBreadcrumbs=""
    let breadcrumbs = "";
    ancestors.forEach((ancestor,index) => {
      breadcrumbs += `${ancestor.name}/`;
      indexBreadcrumbs += `${index}/`;
    });

    let all={ancestors, breadcrumbs}
    return all
  }


  get getDataSource(){
    return this.dataSource
  }

  showTreeData(){
    this.visibleTree = true
  }

  hideTreeData(){
    this.visibleTree = false
  }
}





